import React from "react";
import "./Demiurge.sass";
import demiurge from "./../../../assets/images/demiurge.png";
import demiurgeMobile from "./../../../assets/images/demiurge-mobile.png";

export default function Demiurge() {
  return (
    <div className="demiurge">
      <div className="demiurge-bg">
        <div className="demiurge-container">
          <div className="demiurge-text">
            <h2>
              <strong>KEK, THE DEMIURGE</strong>
            </h2>
            <p>
              is a benevolent being who has fashioned a Metaverse where all
              friends can be comfy and <strong>free from Wage Slavery</strong>{" "}
              through his Frenconomy.
            </p>
            <br />
            <br />
            <p>
              This is a wonderful place with eternal gains for all. Zuck “the
              Cuck” seeing this is currently trying to perpetrate a hostile
              takeover to ruin the comfy times ahead putting the Frens into the
              Bezos Wage Cage. A permanent internet Wage Cage. If their devious
              plan succeeds, the future of the Frens and the entire Metaverse
              itself will never be secure! The comfy NEET lifestyle will never
              be attainable again!
            </p>
          </div>
          <div className="demiurge-image">
            <img src={demiurge} className="not-mobile" alt="demiurge" />
            <img src={demiurgeMobile} className="mobile" alt="demiurge" />
          </div>
        </div>
      </div>
    </div>
  );
}
